var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.userInfo.isAuditDiagnose == 'True' ? 'titleTopCenterLeftBox' : 'titleTopCenterLeftBoxno',on:{"click":_vm.goDoctor}},[_vm._v("处方审核"),_c('el-badge',{staticClass:"item",attrs:{"value":_vm.waitDataTotalNumber}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }